import { render, staticRenderFns } from "./ViewWithBar.vue?vue&type=template&id=170f6f28&scoped=true&"
import script from "./ViewWithBar.vue?vue&type=script&lang=js&"
export * from "./ViewWithBar.vue?vue&type=script&lang=js&"
import style0 from "./ViewWithBar.vue?vue&type=style&index=0&id=170f6f28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "170f6f28",
  null
  
)

export default component.exports